export function ColorChecker(hexColor) {
    const hexToRgb = (hex) => {
      hex = hex.replace(/^#/, '');
      const bigint = parseInt(hex, 16);
      const red = (bigint >> 16) & 255;
      const green = (bigint >> 8) & 255;
      const blue = bigint & 255;
      return { red, green, blue };
    };
  
    const isCloseToWhite = () => {
      if (!hexColor) return false;
      const threshold = 30;
      const { red, green, blue } = hexToRgb(hexColor);
      const isCloseRed = red >= 255 - threshold;
      const isCloseGreen = green >= 255 - threshold;
      const isCloseBlue = blue >= 255 - threshold;
      return isCloseRed && isCloseGreen && isCloseBlue;
    };
  
    // Return the result of the color check
    return isCloseToWhite();
  }
  